module.exports = __webpack_public_path__ + "img/a5.25331cf1.png";